import { useContext } from 'react';
import { AppContext } from '../contexts/AppContextProvider';
import useGetUserData from './useGetUserData';

export function useBrandedUserData() {
  const { brand } = useContext(AppContext);
  return useGetUserData(brand);
}
